import { Checkbox, Input } from "@/components/ui"
import { CopyMinus, CopyPlus, EyeIcon, Pencil, Search, Trash2, ZoomIn, ZoomOut } from "lucide-react"
import { taskOption } from "./consts"
import { Loader, Select } from "@/components"

const Toolbar = ({onExpandAll,
  onCollapseAll,
  zoomIn,
  zoomOut,
  showEditDelete,
  isDeletePending,
  onDeleteTask,
  onToday,
  onChangeTask,
  currTask,
  globalFilter,
  setGlobalFilter,
  onEditClick, showView}: any) => {
    return (
    <div className="py-2 px-3 flex flex-col lg:flex-row lg:items-center justify-between bg-primary-100 border-b-1 text-[15px] font-[600]">
      <div className="flex flex-col md:flex-row gap-2 md:gap-3">
        <div
          className="flex flex-row gap-1 cursor-pointer"
          onClick={onExpandAll}
        >
          <CopyPlus className="h-5" /> Expand All
        </div>
        <div
          className="flex flex-row gap-1 cursor-pointer"
          onClick={onCollapseAll}
        >
          <CopyMinus className="h-5" /> Collapse All
        </div>
        <div
          className="flex flex-row gap-1 cursor-pointer"
          onClick={zoomIn}
        >
          <ZoomIn className="h-5" /> Zoom In
        </div>
        <div
          className="flex flex-row gap-1 cursor-pointer"
          onClick={zoomOut}
        >
          <ZoomOut className="h-5" /> Zoom Out
        </div>
        {showEditDelete ? <><button disabled={isDeletePending} className="flex flex-row gap-1 cursor-pointer" onClick={onEditClick}>
          <Pencil className="h-5" /> Edit
        </button>
        <button className="flex flex-row gap-1 cursor-pointer" onClick={onDeleteTask} disabled={isDeletePending}>
          <Trash2 className="h-5" /> {isDeletePending ? <Loader variant="secondary" /> : <></>} Delete
        </button></> : <></>}
        {showView ? <button className="flex flex-row gap-1 cursor-pointer" onClick={onEditClick}>
          <EyeIcon className="h-5" /> View
        </button> : <></>}
      </div>
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-5 mt-2 lg:mt-auto">
        <div className="flex flex-row items-center gap-2">
          <Checkbox onCheckedChange={onToday} /> Today
        </div>
        <div className="w-[200px]">
          <Select
            options={taskOption}
            onChange={onChangeTask}
            placeholder="Select task"
            value={currTask}
          />
        </div>
        <div>
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
        </div>
      </div>
    </div>
  )
}

export default Toolbar;